import Vue from "vue";
import store from "./store";
import router from "./router";

Vue.prototype.$setLocalStorage = (key, value) => {
    try {
        window.localStorage.setItem(key, value);
    } catch (error) {
        console.log(error);
    }
};

Vue.prototype.$getLocalStorage = key => {
    try {
        const item = window.localStorage.getItem(key);
        return item ? item : null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

Vue.prototype.$deleteLocalStorage = key => {
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch (error) {
        console.log(error);
        return null;
    }
};

Vue.prototype.$checkSession = () => {
    let limit = 24 * 3600 * 1000; // 24 hour
    const rememberMe = Vue.prototype.$getLocalStorage("thriveAppTokenRemember");

    if (rememberMe === "true") {
        limit = limit * 7;
    }

    let localStorageInitTime = localStorage.getItem("thriveAppTokenInitTime");

    if (localStorageInitTime === null) {
        return "";
    }

    if (+new Date() - localStorageInitTime > limit) {
        Vue.prototype.$deleteLocalStorage("thriveAppToken");
        Vue.prototype.$deleteLocalStorage("thriveAppTokenInitTime");
        Vue.prototype.$deleteLocalStorage("thriveAppTokenRemember");
    }

    return Vue.prototype.$getLocalStorage("thriveAppToken");
};

Vue.prototype.$api_url = document
    .querySelector("#appApiUrl")
    .getAttribute("content");

Vue.prototype.$token = {
    // value: Vue.prototype.$getLocalStorage("thriveAppToken"),
    value: Vue.prototype.$checkSession()
};

Vue.prototype.$tokenTemp = null;

Vue.prototype.$isLoad = () => store.state.load > 0;

Vue.prototype.$load = (num = -1) => {
    store.commit("load", num === 1 ? 1 : -1);
    if (store.state.load > 0) {
        document.addEventListener("keydown", blockEvent);
        document.addEventListener("click", blockEvent);
    } else {
        document.removeEventListener("keydown", blockEvent);
        document.removeEventListener("click", blockEvent);
    }
};

const blockEvent = e => {
    e.preventDefault();
    return false;
};

Vue.prototype.$user = key => {
    if (store.state.user && store.state.user[key] !== undefined) {
        return store.state.user[key];
    }
    return "";
};

Vue.prototype.$getState = key => {
    return store.state[key];
};

Vue.prototype.$setState = (type, payload) => {
    store.commit(type, payload);
};

Vue.prototype.$checkUser = (user, token) => {
    if (user.id === undefined) return true;

    if (!token && user.has_avatar === 0) {
        store.commit("loginActiveStep", "signUp");
        store.commit("startSign", false);
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.phone) {
        store.commit("loginActiveStep", "phone");
        store.commit("loginSteps", { signUp: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.is_verified) {
        store.commit("loginActiveStep", "verification");
        store.commit("loginSteps", { signUp: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.pr_npo) {
        store.commit("loginActiveStep", "cause");
        store.commit("loginSteps", { signUp: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.pr_bank) {
        store.commit("loginActiveStep", "bank");
        store.commit("loginSteps", { cause: true, signUp: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.pr_card) {
        store.commit("loginActiveStep", "card");
        store.commit("loginSteps", { cause: true, signUp: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else if (!user.pr_donation) {
        store.commit("loginActiveStep", "donation");
        store.commit("loginSteps", { cause: true, signUp: true, card: true });
        store.commit("loginOperation", "signUp");
        return false;
    } else {
        return true;
    }
};

/**
 * Route permission validation
 *
 * @return boolean
 */
Vue.prototype.$access = to => {
    let user = store.state.user,
        meta = Object.assign(...to.matched.map(item => item.meta)),
        auth = meta.auth === 1,
        guest = meta.auth === 0,
        logged = meta.auth === 2;

    if (user === null) {
        return false;
    }

    if ((guest && user) || (auth && !user)) {
        router.push("/login").catch(failure => {
            console.log(failure.to.path);
        });
        return false;
    }

    if (logged && user) {
        if (Vue.prototype.$checkUser(user)) {
            router.push("/dashboard").catch(failure => {
                console.log(failure.to.path);
            });
        } else {
            if (to.path !== "/login") {
                router.push("/login").catch(failure => {
                    console.log(failure.to.path);
                });
                return false;
            }
        }
        // router.push("/dashboard");
    }

    if (user && (!user.pr_npo || !user.pr_bank || !user.pr_card)) {
        if (!Vue.prototype.$checkUser(user)) {
            if (to.path !== "/login") {
                router.push("/login").catch(failure => {
                    console.log(failure.to.path);
                });
                return false;
            }
        }
    }
    document.title = to.name;
    return true;
};

Vue.prototype.$checkAvatar = avatar => {
    if (avatar === 0) {
        router.push("/settings").catch(failure => {
            console.log(failure.to.path);
        });
    }
};

Vue.prototype.$scrollToTop = (y = 0) => {
    window.scrollTo(0, y);
};

Vue.prototype.$currentDate = () => {
    const today = new Date();
    let year = String(today.getFullYear());
    let month = String(today.getMonth() + 1);
    let day = String(today.getDate());

    month = month.length === 1 ? "0" + month : month;
    day = day.length === 1 ? "0" + day : day;

    return `${month}.${day}.${year}`;
};

Vue.prototype.$isNumeric = n => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

Vue.prototype.$isEmptyObj = obj => {
    for (let key in obj) {
        return false;
    }
    return true;
};

Vue.prototype.$tConvert = time => {
    // Check correct time format and split into components
    time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
};
